import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sortExamTypes',
    standalone: false
})
export class SortExamTypesPipe implements PipeTransform {

  transform(examTypes: any[]): any[] {
    const order = ['1st', 'NT', 'Early Anatomy', 'Late Anatomy', 'Specialized', 'Third Scan'];

    return examTypes.sort((a, b) => {
      const indexA = order.indexOf(a.examType);
      const indexB = order.indexOf(b.examType);

      if (indexA === -1 && indexB === -1) {
        return 0; 
      } else if (indexA === -1) {
        return 1;
      } else if (indexB === -1) {
        return -1; 
      } else {
        return indexA - indexB; // Both are in the order array, sort by their index
      }
    });
  }

}
